import React from 'react';

export const ArrowIcon = (props) => {
  return (
    <svg viewBox='0 0 30 30' fill='currentColor' height='1em' width='1em' {...props}>
      <g id='icon/arrow' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='ep:arrow-up-bold' transform='translate(2.500000, 2.500000)'>
          <rect id='ViewBox' x='0' y='0' width='25' height='25'></rect>
          <path
            d='M2.55625,16.7296875 C3.16640602,17.3396593 4.15546898,17.3396593 4.765625,16.7296875 L12.5,8.9953125 L20.234375,16.7296875 C20.847467,17.3218316 21.8220075,17.3133631 22.4247165,16.710654 C23.0274256,16.107945 23.0358941,15.1334045 22.44375,14.5203125 L13.6046875,5.68125 C12.9945315,5.07127822 12.0054685,5.07127822 11.3953125,5.68125 L2.55625,14.5203125 C1.94627822,15.1304685 1.94627822,16.1195315 2.55625,16.7296875 L2.55625,16.7296875 Z'
            id='Path'
            fill='currentColor'
            fillRule='nonzero'
          ></path>
        </g>
      </g>
    </svg>
  );
};
